var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(" Contragents ")]),_c('alert',{ref:"alert"}),_c('ContragentsTable',{attrs:{"contragents":_vm.contragents},on:{"deleteContragent":_vm.deleteContragents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }